module.exports = __webpack_public_path__ + "static/logo-header-596d4e305e92ebaa861d9c5583ce4d7c.svg";